module.exports = __webpack_public_path__ + "static/media/hotel.ee4df5c5.jpg";